import { message } from "antd";
import axios from "axios";
import React, { Component } from "react";
import { connect } from "react-redux";
import {
    Form,
    ModalItem,
    FormItem,
    InputItem,
    ButtonItem,
    ErrorItem,
    InputNumberItem,
} from "../../../../Components/Items";
import SelectEmpleadosItem from "../../../../Components/SelectEmpleadosItem";
import SelectRelojesChecadoresItem from "../../../../Components/SelectRelojesChecadoresItem";

class EditarAsignacionReloj extends Component {
    formRef = React.createRef();
    state = {
        loading: false,
    };
    componentDidUpdate(prevProps) {
        if (this.props.visible !== prevProps.visible && this.props.visible)
            this.consultarTodo();
    }
    cerrarEditarAsignacionReloj(codigo) {
        this.props.cerrarEditarAsignacionReloj(codigo);
    }
    async consultarTodo() {
        this.setState({ loading: true });
        await axios
            .post(
                "asignacionesRelojes/datosAsignacionReloj",
                { empresaId: this.props.empresaId, asignacionRelojId: this.props.asignacionRelojId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                if (res.data.success === 2) {
                    this.formRef.current.setFieldsValue({
                        ...res.data.data,
                    });
                } else {
                    message.error(res.data.message || "Error no se encontro informacion de la asignacion de reloj");
                }
            });
        this.setState({ loading: false });
    }
    onFinishFailed(e) {
        ErrorItem(e);
    }
    onFinish(values) {
        this.setState({ loading: true });
        axios
            .post(
                "asignacionesRelojes/editarAsignacionReloj",
                { ...values, empresaId: this.props.empresaId, asignacionRelojId: this.props.asignacionRelojId },
                { headers: this.props.headersToken }
            )
            .then((res) => {
                this.setState({ loading: false });
                if (res.data.success === 2) {
                    message.success("Se ha editado una asignacion de reloj");
                    this.formRef.current.resetFields();
                    this.cerrarEditarAsignacionReloj(res.data.codigo);
                } else if (res.data.success === 1) {
                    message.error("No se puede editar la asignacion de reloj");
                } else {
                    message.error("Hubo un error y la asignacion de reloj no se edito");
                }
            });
    }
    render() {
        return (
            <>
                <ModalItem
                    title="Editar Asignacion de Reloj"
                    visible={this.props.visible}
                    spinning={this.state.loading}
                    onCancel={this.cerrarEditarAsignacionReloj.bind(this)}
                    paddingTop
                >
                    <Form
                        ref={this.formRef}
                        name="editarAsignacionReloj"
                        layout
                        bottom={
                            <ButtonItem
                                type="primary"
                                htmlType="submit"
                                style={{ display: "block", margin: "0 0 0 auto" }}
                            >
                                Editar
                            </ButtonItem>
                        }
                        onFinish={this.onFinish.bind(this)}
                        onFinishFailed={this.onFinishFailed}
                    >
                        <FormItem
                            name="nombre"
                            label="Nombre"
                            max={100}
                            margin
                            pattern
                        >
                            <InputItem placeholder="Nombre" />
                        </FormItem>
                        <FormItem
                            label="Reloj Checador"
                            name="relojChecadorId"
                            fieldKey="relojChecadorId"
                            margin
                        >
                            <SelectRelojesChecadoresItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Reloj Checador"
                            />
                        </FormItem>
                        <FormItem
                            label="Empleado"
                            name="empleadoId"
                            fieldKey="empleadoId"
                            margin
                        >
                            <SelectEmpleadosItem
                                empresaId={this.props.empresaId} // o donde sea que tengas almacenado el ID de la empresa
                                headersToken={this.props.headersToken}
                                sinBorde
                                autoFocus
                                dropdownMatchSelectWidth={600}
                                width="100%"
                                placeholder="Empleados"
                            />
                        </FormItem>
                        <FormItem
                            name="usuarioRelojChecador"
                            label="Usuario Reloj"
                            required
                            type="number"
                            margin
                            pattern
                        >
                            <InputNumberItem placeholder="Usuario Reloj" />
                        </FormItem>
                    </Form>
                </ModalItem>
            </>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        headersToken: state.user.headersToken,
        empresaId: state.empresa.id,
    };
};

export default connect(mapStateToProps)(EditarAsignacionReloj);
